<template>
  <div>
    <v-data-table :headers="headers" :items="data">
      <template slot="items" slot-scope="props">
        <tr style="text-align: left">
          <td>
            <v-btn icon color="primary" @click="openService(props.item)">
              <v-icon>visibility</v-icon>
            </v-btn>
          </td>
          <td>{{ props.item.ApplicationID }}</td>
          <td>{{ dueDate(props.item) }}</td>
          <td>{{ userName(props.item.Application.User) }}</td>
          <td>{{
            primarySiteName(props.item.Application.PracticeSiteInformation)
          }}</td>
          <td>{{ currentStatus(props.item.CurrentStatus) }}</td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="1050px" v-if="dialog">
      <service-card
        :service="service"
        v-on:closeService="closeService"
        v-on:saved="getDataAndUpdateService"
      ></service-card>
    </v-dialog>
  </div>
</template>

<script>
import ServiceConfirmationVue from '../ServiceConfirmation/ServiceConfirmation'
import { authComputed } from '@state/helpers'
import moment from 'moment'
export default {
  data() {
    return {
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'Application', value: 'ApplicationID' },
        { text: 'Due On', value: 'dueDate', sortable: false },
        { text: 'HealthCare Provider', value: 'FirstName' },
        { text: 'Site', value: 'StieInsitutionName' },
        { text: 'Status', value: 'Description' },
      ],
      data: [],
      dialog: false,
      service: {},
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getDataAndUpdateService(item) {
      this.service = item
      this.getData()
    },
    getData() {
      axios
        .get('ServiceConfirmation')
        .then((res) => {
          this.data = res.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    currentStatus(status) {
      if (status.Status) {
        return status.Status.Description
      }
      return 'Not Submitted'
    },
    primarySiteName(sites) {
      let name = ''
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          name = i.SiteAddress.SiteInsitutionName
        }
      })
      return name
    },
    userName(user) {
      if (user) {
        return `${user.FirstName} ${user.LastName}`
      }
      return ''
    },
    canSubmit(application) {
      let start = moment(application.DateReward).add(90, 'days')
      if (moment(new Date()) > start) {
        return true
      }
      return false
    },
    dueDate(service) {
      return moment(service.Application.DateReward)
        .add(90, 'days')
        .format('MM/DD/YYYY')
    },
    openService(item) {
      this.service = {}
      this.service = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    closeService() {
      this.service = {}
      this.dialog = false
    },
  },
  computed: {
    ...authComputed,
  },
  components: {
    'service-card': ServiceConfirmationVue,
  },
}
</script>

<style></style>
